import { PlanFragment } from 'src/graphql'

const getPlan = (
  plans: PlanFragment[] | undefined,
  planId: string,
): PlanFragment | undefined => plans?.find(plan => plan.stripeId === planId)

export default getPlan
